import { HashRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import Services from './pages/Services';
import Client from './pages/Client';
import Career from './pages/Career';
import Contact from './pages/Contact';
import Business from './pages/Business';
import ManagementTeam from './pages/ManagementTeam'; // ← NEW
import OurPeoples from './pages/OurPeoples';           // ← NEW
import './styles/global.css';
import './styles/responsive.css';
import AirtelVerification from "./pages/Airtel-Verification";
import AircelVerification from "./pages/aircel-verification";
import VodafoneCollection from "./pages/VodaFone-Collection";
import Mobikwik from "./pages/Mobikwik";
import DenRetention from "./pages/Den-Retention";
import AirtelSimDelivery from "./pages/Airtel-SimDelivery";
import AirtelRetention from "./pages/Airtel-Retention";
export default function App() {
  return (
    <HashRouter>
      <Header />
      <main>
        <Routes>
          <Route path="/"                        element={<Home />} />
          <Route path="/about"                   element={<About />} />
          <Route path="/about/software-development" element={<SoftwareDevelopment />} />
         <Route path="/client" element={<Client />} />
          <Route path="/services"                element={<Services />} />
          <Route path="/career"                  element={<Career />} />
          <Route path="/contact"                 element={<Contact />} />
          <Route path="/business"                element={<Business />} />
          <Route path="/management-team"         element={<ManagementTeam />} /> {/* ← NEW */}
          <Route path="/our-peoples"             element={<OurPeoples />} />     {/* ← NEW */}
           <Route path="/Airtel-Verification" element={<AirtelVerification />} />
        <Route path="/aircel-verification" element={<AircelVerification />} />
        <Route path="/VodaFone-Collection" element={<VodafoneCollection />} />
        <Route path="/Mobikwik" element={<Mobikwik />} />
        <Route path="/Den-Retention" element={<DenRetention />} />
        <Route path="/Airtel-SimDelivery" element={<Airtel-SimDelivery />} />
        <Route path="/Airtel-Retention" element={<Airtel-Retention />} />
        </Routes>
      </main>
      <Footer />
    </HashRouter>
  );
}
